/**
 * ═══════════════════════════════════════
 * Calendar App - Punto de entrada React
 * ═══════════════════════════════════════
 *
 * Monta el componente AvailabilityCalendar en #calendar-app.
 * Solo se carga en single-tour.php (sidebar).
 *
 * @package AusangateExpeditions
 * @since   1.0.0
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import AvailabilityCalendar from './components/AvailabilityCalendar';

document.addEventListener( 'DOMContentLoaded', () => {
	const container = document.getElementById( 'calendar-app' );

	if ( ! container ) return;

	const tourId       = parseInt( container.dataset.tourId, 10 ) || 0;
	const cuposMaximos = parseInt( container.dataset.cuposMaximos, 10 ) || 0;
	const config       = window.turismoData || {};

	const root = createRoot( container );

	root.render(
		<React.StrictMode>
			<AvailabilityCalendar
				tourId={ tourId }
				cuposMaximos={ cuposMaximos }
				restUrl={ config.restUrl || '/wp-json/' }
				bookingUrl={ config.bookingUrl || '/reservar/' }
			/>
		</React.StrictMode>
	);
});
